import { render } from "./ProjectContract.vue?vue&type=template&id=0348d2e0"
import script from "./ProjectContract.vue?vue&type=script&lang=js"
export * from "./ProjectContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__